import React from 'react';
import { Col } from 'antd';
import './TopFilterColButton.scss';
import { ColProps } from 'antd/lib/col';

export interface TopFilterColButtonProps extends ColProps {}

export function TopFilterColButton(props: TopFilterColButtonProps) {
  const { className, span, ...otherProps } = props;
  return (
    <Col span={span ?? 24} className="top-filter-col-button" {...otherProps} />
  );
}
